import { createSelector } from 'reselect';

export default createSelector(
  state => state.auth,
  auth => auth.user_id,
);
